import {Modal, Table, Typography, Button} from 'antd';
import React from 'react';

import {drawerZIndex} from '../../../constants/Common';
import {frameworkRoute} from '../constants/frameworkRoutes';

interface PrefillMappingModalProps {
  open: boolean;
  onCancel: () => void;
  framework: string;
  selectedYear: string | null;
  frameworkMappingData: any[];
  columns: any[];
  onConfirm: () => void;
}

const PrefillMappingModal: React.FC<PrefillMappingModalProps> = ({
  open,
  onCancel,
  framework,
  selectedYear,
  frameworkMappingData,
  columns,
  onConfirm
}) => {
  return (
    <Modal
      title={
        <Typography.Text strong style={{fontSize: 18, color: '#1e3d29'}}>
          {framework === frameworkRoute.BRSR
            ? `The following fields of BRSR will be prefilled from GRI (${selectedYear})`
            : `The following fields of GRI will be prefilled from BRSR (${selectedYear})`}
        </Typography.Text>
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      width={1000}
      zIndex={drawerZIndex}
    >
      <div className="hidden-scroll-table-prefill">
        <Table
          columns={columns}
          dataSource={frameworkMappingData}
          pagination={false}
          className="prefillPopup"
          showHeader={true}
          bordered
          scroll={{y: 500}}
          rowClassName={() => 'custom-row-prefill'}
          style={{
            marginTop: 20,
            marginBottom: 20,
            overflow: 'hidden',
            borderRadius: 8
          }}
        />
      </div>

      <Button
        type="primary"
        style={{
          backgroundColor: '#1b744f',
          borderRadius: '50px',
          color: '#fff',
          borderColor: '#1b744f',
          padding: '8px 20px',
          height: 'auto',
          fontWeight: 'bold',
          fontSize: '16px'
        }}
        onClick={onConfirm}
      >
        Confirm
      </Button>
    </Modal>
  );
};

export default PrefillMappingModal;
